import { apiSlice } from '../app/api/apiSlice';

export const externalOrdersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getExternalOrders: builder.query({
      query: ({ page = 1, limit = 10, search = '', status = '', environment = '' } = {}) => {
        const params = new URLSearchParams();
        if (page) params.append('page', page);
        if (limit) params.append('limit', limit);
        if (search) params.append('search', search);
        if (status) params.append('status', status);
        if (environment) params.append('environment', environment);

        return {
          url: `external-order${params.toString() ? `?${params.toString()}` : ''}`,
          headers: {
            'x-api-key': 'riise',
          },
        };
      },
      validateStatus: (response, result) => {
        return response.status === 200 && !result.isError;
      },
    }),
    updateOrderStatus: builder.mutation({
      query: (payload) => ({
        url: `external-order/update-status`,
        method: 'PATCH',
        body: { ...payload },
        headers: {
          'x-api-key': 'riise',
        },
      }),
    }),
  }),
});

export const { useGetExternalOrdersQuery, useUpdateOrderStatusMutation } = externalOrdersApiSlice;
